<template>
  <v-dialog v-model="dialog" width="300" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" text v-on="on">Attach Organization</v-btn>
    </template>
    <v-card>
      <v-container class="text-center">
        <div class="mb-3">
          <h2 class="mt-2 headline">
            <span class="deep-orange--text font-weight-bold">Attach Organization</span>
          </h2>
          <span class="caption">Email address & password of your organization</span>
        </div>

        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="loginEmail"
              :error-messages="emailErrors"
              :hide-details="emailErrors.length === 0"
              :label="$t('labels.email')"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="loginPassword"
              outlined
              dense
              :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword ? 'text' : 'password'"
              :label="$t('labels.password')"
              v-on:keyup.enter="submit"
              :error-messages="passwordErrors"
              :hide-details="passwordErrors.length === 0"
              @input="$v.loginPassword.$touch()"
              counter="counter"
              @click:append="showPassword = !showPassword"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-btn block text to="/forgotPassword">{{ $t("buttons.forgotPassword") }}</v-btn>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="6">
            <v-btn text @click="dialog = false">Close</v-btn>
          </v-col>
          <v-col cols="6" class="shrink">
            <v-btn @click="submit" color="primary">{{ $t("buttons.attach") }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import authService from "../../SignUp/service";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  data() {
    return {
      showPassword: false,
      loginEmail: null,
      loginPassword: null,
      dialog: false
    };
  },
  mixins: [validationMixin],
  validations: {
    loginEmail: {
      email,
      required
    },
    loginPassword: {
      required
    }
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"]),
    emailErrors() {
      const errors = [];
      if (!this.$v.loginEmail.$dirty) return errors;
      if (!this.$v.loginEmail.email) errors.push("Email is not valid");
      if (!this.$v.loginEmail.required) errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.loginPassword.$dirty) return errors;
      if (!this.$v.loginPassword.required) errors.push("Password is required.");
      return errors;
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: "Invalid Input"
          });
      } else {
        this.$Progress.start();
        authService
          .attach({
            loginEmail: this.loginEmail,
            loginPassword: this.loginPassword
          })
          .then(response => {
            // console.log('response, response', response)
            this.$Progress.finish();
            this.$store.dispatch("global/initOrganization");
            this.$swal("Attach Organization", "Organization was attach successfully", "success");
            this.dialog = false;
          })
          .catch(error => {
            this.$Progress.finish();
            console.log(error);
            this.$swal("Invalid Login", "Check email and password", "error");
          });
      }
    }
  }
};
</script>

<style scoped></style>
